<template>
	<div class="col-md-6 col-md-offset-3">
		<div class="panel panel-default drop-shadow">
			<div class="panel-heading panel-dark text-center">
				<b>LOGIN</b>
			</div>
			
			<div class="panel-body">
				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							<b>Email:</b>
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="email"  type="text"  class="form-control" style='width:100%; v-align:middle;' autofocus
								v-validate="'required|max:250'"
								v-model="email"
						>
						<span class="text-danger">{{ errors.first('email') }}</span>
					</div>
				</div>
				<br><br>

				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							<b>Password:</b>
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="password"  type="password"  class="form-control" style='width:100%; v-align:middle;'
								v-validate="'required|max:50'"
								v-model="password"
						>
						<span class="text-danger">{{ errors.first('password') }}</span>
					</div>
				</div>

				<br>&nbsp;<br>

				<div class="form-group">
					<div class="col-md-6 col-md-offset-6">
						<label class="control-label">
							<b><a href="/forgot">Forgot Password?</a></b>
						</label>
						<button  v-if="requesting == false"
								 name="button"  type="submit"  class="btn btn-primary btn-block"
								 @click="send_login()"
    							 :disabled="errors.any() || !is_complete"
						>Submit</button>

						<button v-else  disabled
								name="button"   type="submit"  class="btn btn-primary btn-block">
							<i class="fas fa-circle-notch fa-spin"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';               // Google reCaptcha


export default {
	components: {
        VueRecaptcha,
	},

    data() {
		return {
			env: process.env.VUE_APP_ENV,
		}
    },
    
    computed: {
        is_complete() {
            let  ok = true;
            
            // Email must be entered
            if (this.email == false) {
                ok = false;
            }

            // Password must be entered
            if (this.password == false) {
                ok = false;
            }

            return ok;
        },
    },

	data() {
		return {
			requesting: false,
			email:      '',
			password:   '',
            recaptcha:  false,
		};
	},

	methods: {
        // Recaptcha events:
        // Token received (ie, reCaptcha was completed by the user)
        recaptcha_token(response) {
            //console.log('reCaptcha token = ', response);
            this.recaptcha = response;
        },
        // ReCaptcha expired 
        recaptcha_expired() {
            //console.log('reCaptcha expired');
            this.recaptcha = false;
        },

		// User login Method
		send_login() {
			this.requesting = true;

            // Set dummy recaptcha if development environment
            if (this.env == "development") {
                this.recaptcha = 'dummyval';
            }
            this.recaptcha = 'dummyval';
			
			this.$validator.validateAll()
			.then(() => {
				const post_data = {
					email:     this.email,
                    password:  this.password,
                    recaptcha: this.recaptcha,
				};

				this.axios.post('api/login', post_data)
				.then(response => {
					localStorage.setItem('api_token', response.data.api_token);
					//this.$store.commit("USER_NAME", response.data.name);

					this.$parent.rerender_header();

					this.$notify({
						group:    'fs_success',
						title:    'Success',
						text:     'Login successful',
						duration: 1000,
						type:     'success'
					});
					
					this.$router.push({ "name": "home" });
				})
				.catch(error => {
					this.requesting = false;
			
					localStorage.removeItem('api_token');
					this.$store.commit("RESET");
                    this.api_token = null;
					
					var error_msg     = '';
					var error_details = '';
					if (error.response.data.message) {
						error_msg = error.response.data.message;	
					}
					
					if (error.response.data.error) {
						Object.keys(error.response.data.error).forEach(key => {
							error_details = error_details + error.response.data.error[key].toString() + "<br>";

							// load api errors into client errors
							this.errors.add({
								field: key,
								msg:   error.response.data.error[key].toString(),
							});
						});
					}

                    this.$notify({
                        group: 'fs_danger',
                        title: error_msg,
                        text:  error_details,
                        type:  'error'
                    });
				});
			})
			.catch(() => {
				this.requesting = false;
			
				this.$notify({
					group: 'fs_danger',
					title: 'Error',
					text:  this.errors.all(),
					type:  'error'
				});
			});
		},
	}
};
</script>

<style>
#recaptcha {
    margin: 0px;
    width: 304px;
    position: relative;
    float: right;
}

#recaptcha iframe {
    position: absolute;
    left: 0px;
    top: 0px;
}
</style>